import { render } from "./MobileHomePage.vue?vue&type=template&id=3fc52de0"
import script from "./MobileHomePage.vue?vue&type=script&lang=js"
export * from "./MobileHomePage.vue?vue&type=script&lang=js"

import "./MobileHomePage.vue?vue&type=style&index=0&id=3fc52de0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__